import styled, { css } from 'styled-components'

interface InputProps {
  isFocused: boolean;
  rows?: number;
  isIncorrect?: boolean;
  width?: string | number | undefined;
  disabled?: boolean;
}

export const InputContainer = styled.div`
  &&& {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 0;
  
    small {
      font-weight: 400;
      font-size: 14px;
      line-height: 21px;
      color: #E84242;
      white-space: nowrap;
    }
  }
`

export const InputLabel = styled.span<{ labelSize: 'small' | 'high', isIncorrect?: boolean }>`
  &&& {
    color: ${props => props.isIncorrect ? '#E84242' : '#353744'};
    font-weight: 900;
    font-size: ${props => props.labelSize === 'small' ? '14px' : '24px'};
    line-height: ${props => props.labelSize === 'small' ? '21px' : '34px'};
    margin-bottom: ${props => props.labelSize === 'small' ? '0' : '12px'};
  }

  b {
    font-size: ${props => props.labelSize === 'small' ? '16px' : '26px'};
  }
`

export const InputBox = styled.div<InputProps>`
  width: ${props => props.width ? props.width : '100%'};
  min-height: 40px;
  height: ${props => props.rows ? `${24 * props.rows}px` : 'fit-content'};
  border: 1px solid #C8C8C8;
  background-color: ${props => props.disabled ? '#F6F7FD' : '#fff'};
  padding: 6px 6px 6px 16px;
  ${props => props.isFocused && css`
    border: 2px solid #3D6666;
  `}
  ${props => props.isIncorrect && css`
    border: 1px solid #E84242;
  `}

  input {
    width: 100%;
    font-size: 16px;
    line-height: 24px;
    color: ${props => props.disabled ? '#94A3B8' : '#353744'};
    border: none;
    background-color: ${props => props.disabled ? '#F6F7FD' : '#fff'};

    &::-webkit-outer-spin-button, &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
      -moz-appearance: textfield;
    }
  }

  textarea {
    height: 100%;
    width: 100%;
    font-size: 16px;
    line-height: 24px;
    color: #353744;
    border: none;
    background-color: #fff;
    resize: none;
  }
`